var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-tabs" },
    [
      _c("div", { staticClass: "content-wrapper" }, [_c("router-view")], 1),
      _c(
        "van-tabbar",
        {
          staticClass: "h-[50px] z-999",
          attrs: { route: "" },
          on: { change: _vm.onChange },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c("van-tabbar-item", {
            attrs: { to: { name: "cartTab" } },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "w-8 h-8",
                      attrs: { src: _vm.cardSrc, alt: "" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("van-tabbar-item", {
            attrs: { to: { name: "home" } },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "w-10 h-10",
                      attrs: { src: _vm.homeSrc, alt: "" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("van-tabbar-item", {
            attrs: { to: { name: "mine" } },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "w-10 h-10",
                      attrs: { src: _vm.mineSrc, alt: "" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }